import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Input, message } from "antd";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { updateAccountDetails } from "Sdk/Actions";
import { getUserDetailsFromReducer } from "Store/reducers/Auth/AuthSlice";
import { NormalizeLink } from "Utility/Common/Methods";
import { InputClass } from "Utility/Contants/Styles";

export const GetSocialLinks = ({ platformName }) => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const [addButtonLoader, setaddButtonLoader] = useState(false);

  const isWhatsApp = platformName === "whatsapp";

  // Get existing link or number from userDetails
  const existingLink = userDetails?.[platformName] || "";
  const initialNumber = isWhatsApp
    ? existingLink.replace("https://wa.me/", "")
    : existingLink;
  const [link, setLink] = useState(initialNumber);

  useEffect(() => {
    const updatedValue = userDetails?.[platformName] || "";
    setLink(
      isWhatsApp ? updatedValue.replace("https://wa.me/", "") : updatedValue
    );
  }, [userDetails, platformName ,isWhatsApp]);

  const handleLinkSubmit = async (value) => {
    try {
      setaddButtonLoader(true);
      let updatedLink = value[platformName];

      if (isWhatsApp) {
        // Only create WhatsApp link if user entered a number
        updatedLink = updatedLink ? `https://wa.me/${updatedLink}` : "";
      } else {
        // Normalize other links
        updatedLink = NormalizeLink(updatedLink);
      }

      // Update database
      const userData = {
        username: userDetails.username,
        [platformName]: updatedLink,
      };
      await updateAccountDetails(userData);

      setLink(updatedLink);
      message.success(`${platformName} updated successfully!`);
    } catch (error) {
      console.error(`Failed to update ${platformName}:`, error);
      message.error(`Failed to update ${platformName}.`);
    } finally {
      setaddButtonLoader(false);
    }
  };

  return (
    <div>
      <Form
        onFinish={handleLinkSubmit}
        initialValues={{ [platformName]: link }}
        className="flex gap-5"
      >
        <Form.Item
          name={platformName}
          rules={[
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve(); // Allow empty field

                if (isWhatsApp) {
                  return /^\d{10,15}$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error("WhatsApp number must be 10-15 digits only")
                      );
                }

                return /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/.test(
                  value
                )
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error(`Please enter a valid ${platformName} URL`)
                    );
              },
            },
          ]}
          className="w-full"
        >
          <Input
            type="text"
            className={`${InputClass} w-full`}
            placeholder={
              isWhatsApp
                ? "Enter WhatsApp number (e.g. 1234567890)"
                : `Enter ${platformName} link`
            }
            value={link}
            onChange={(e) => {
              if (isWhatsApp) {
                // Only allow numbers
                setLink(e.target.value.replace(/\D/g, ""));
              } else {
                setLink(e.target.value);
              }
            }}
          />
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={addButtonLoader}
          icon={<FontAwesomeIcon icon={faPlus} />}
        >
          Save
        </Button>
      </Form>
    </div>
  );
};
